
import { useState, useEffect } from 'react'
import TodoInput from './components/TodoInput'
import TodoList from './components/TodoList'
import './App.css'

export default function App() {
  const [todos, setTodos] = useState(() => {
    const saved = localStorage.getItem('todos')
    return saved ? JSON.parse(saved) : []
  })
  const [filter, setFilter] = useState('all')

  useEffect(() => {
    localStorage.setItem('todos', JSON.stringify(todos))
  }, [todos])

  function addTodo(text) {
    if (!text.trim()) return
    setTodos([...todos, { id: Date.now(), text, completed: false }])
  }

  function toggleTodo(id) {
    setTodos(todos.map(t => t.id === id ? { ...t, completed: !t.completed } : t))
  }

  function deleteTodo(id) {
    setTodos(todos.filter(t => t.id !== id))
  }

  function clearCompleted() {
    setTodos(todos.filter(t => !t.completed))
  }

  const filtered = todos.filter(t => {
    if (filter === 'active') return !t.completed
    if (filter === 'done') return t.completed
    return true
  })

  const remaining = todos.filter(t => !t.completed).length

  return (
    <div className="app">
      <div className="card">
        <h1 className="title">My Tasks</h1>
        <TodoInput onAdd={addTodo} />
        <div className="filters">
          {['all', 'active', 'done'].map(f => (
            <button
              key={f}
              className={`filter-btn ${filter === f ? 'active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>
        <TodoList todos={filtered} onToggle={toggleTodo} onDelete={deleteTodo} />
        <div className="footer">
          <span>{remaining} task{remaining !== 1 ? 's' : ''} left</span>
          {todos.some(t => t.completed) && (
            <button className="clear-btn" onClick={clearCompleted}>Clear completed</button>
          )}
        </div>
      </div>
    </div>
  )
}